<template>
  <div class="pic-list">
      <img src="@/assets/common/img/banner1.jpg">
  </div>
</template>

<script>
export default {
  name: 'HomePic',
  props: ['showPic'],
};
</script>

<style scoped>

</style>
